import React, {useContext} from 'react';
import PostPreview from '~/components/PostPreview';
import usePostPreviews from '~/hooks/useBlogPostPreviews';
import TransContext from '~/contexts/TransContext';

export default function RelatedPosts({ posts, heading='' }) {
  const trans = useContext(TransContext);
  const previews = usePostPreviews();

  if (typeof posts[0] === 'string') {
    posts = posts.map(p => previews.filter(preview => preview.uuid === p).pop());
  }

  return (
    <section className="my-20 md:my-28">
      <div className="container">
        <div className="flex ">
          <h2 className="text-h2">{heading || trans?.content?.relatedArticles}</h2>
        </div>
        <div className="flex flex-wrap mt-12 -ml-6">
          {posts?.map((post, i) => (
            <div key={`related${post._uid}-${i}`} className="pl-6 mb-12 md:w-1/3">
              <PostPreview post={post} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
